// @flow
export const EGRIP = 'StatementFromUnifiedRegisterOfIndividualEntrepreneurs'; //Документ о регистрации "ЕГРИП"
export const EGRUL = 'StatementFromUnifiedRegisterOfLegalEntities'; //Документ о регистрации "ЕГРЮЛ"
export const CERTIFICATE = 'CertificateOfStateRegistration'; //Документ о регистрации "Свидетельство юр. лица"
export const CERTIFICATE_TAX_AUTORITY = "CertificateOfRegistrationIntoTaxAuthority"; //Документ свидетельство о постановке на учет в налоговом органе

export const JURIDICAL_TYPES = {
	PHYSICAL: 'Physical',
	JURIDICAL: 'Juridical',
	UNSPECIFIED: 'Unspecified',
};
